import { Icon, Monitor } from "@norican/icons";

import { useT } from "@/i18n";
import { useKiosk } from "@/lib/api";
import { useKioskPerson } from "@/lib/kiosk-person";

import { useKioskNotYou } from "./use-kiosk-not-you";

/**
 * "Shared device · Astrid · Not you?" under the header, on a kiosk session.
 *
 * Shop-floor PCs change hands between shifts without anyone signing out. A
 * strip that names the person on every page is the cheapest way for the next
 * one to notice they are about to file under someone else's name, and the
 * button beside it signs the device out in one press (2 Oct). Renders nothing
 * on a personal session.
 */
export function KioskBanner() {
  const { t } = useT();
  const kiosk = useKiosk();
  const person = useKioskPerson();
  const notYou = useKioskNotYou();

  if (kiosk === null || person === null) {
    return null;
  }

  return (
    <div
      role="note"
      aria-label={t("kiosk.banner.sharedDevice")}
      className="bg-accent-subtle w-full"
    >
      <div className="mx-auto flex w-full max-w-[var(--norican-size-container-xl)] min-w-0 flex-wrap items-center gap-x-2 gap-y-0.5 px-4 py-1.5 text-sm sm:px-6 lg:px-8">
        <Icon icon={Monitor} size="sm" tone="accent" />
        <span className="text-fg font-medium">{t("kiosk.banner.sharedDevice")}</span>
        <span aria-hidden="true">·</span>
        <span className="text-fg min-w-0 truncate">{person.name}</span>
        <span aria-hidden="true">·</span>
        <button
          type="button"
          onClick={notYou}
          className="text-accent-fg-subtle font-medium underline-offset-2 hover:underline"
        >
          {t("filingAs.notYou")}
        </button>
      </div>
    </div>
  );
}
